import type { BodyRouteParamsRequest } from '@pba/utils';
import { changeRequest } from 'common/services';

type RequestToJoinCommunityBody = {
  reason?: string;
};

type RequestToJoinCommunityRouteParams = {
  id: string;
};

export const requestToJoinCommunity = async ({
  body: { reason },
  routeParams: { id },
}: BodyRouteParamsRequest<RequestToJoinCommunityBody, RequestToJoinCommunityRouteParams>) =>
  changeRequest({
    /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
    kind: 'community_request_to_join',
    meta: {
      reason_to_join: reason,
    },
    subject_id: id,
    subject_type: 'Community',
    /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
  });
